<template>
<div class="d-flex" id="wrapper">
  <SideBar />
  <div id="page-content-wrapper">
    <nav style="justify-content:flex-start;" class="navbar navbar-expand-lg navbar-light bg-light border-bottom floating">
      <div>
        <button class="btn btn-outline" id="menu-toggle" @click="sidebar"><span class="navbar-toggler-icon"></span>
        </button>

        <button style="color: rgba(0,0,0,.5);border-color: rgba(0,0,0,.1);" class="btn btn-outline navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
         <span style="padding-top:0.5em;"><i class="fas fa-user-alt"></i><span class="account-div"></span><i class="fas fa-angle-down"></i></span>
        </button>
      </div>
      <div class="d-flex">
        <!-- <i class="fas fa-home text-muted hover-cursor" @click="toPage('/dashboard')"></i> -->
        <p class="text-primary mb-0 hover-cursor">&nbsp;Return / Quality Control</p>
      </div>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              {{ admin }}
            </a>
            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
              <a class="dropdown-item link" @click="toPage('/password')"> <i class="fas fa-cog"></i><span class="right-dropdown">Change Password</span></a>
              <a class="dropdown-item link" @click="handleLogout"><i class="fas fa-sign-out-alt"></i><span class="right-dropdown">Logout</span></a>
            </div>
          </li>
        </ul>
      </div>
    </nav>
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12 grid-margin stretch-card card-div">
          <div class="container">
            <!-- Searchbar -->
            <div class="col-lg-12 px-0">
              <div id="filterPart" class="card" >
                <div class="row">
                  <div class="container" style="display : flex;">
                    <div class="col-4">
                      <div>Unique ID</div>
                      <input type="text" class="form-control" name="search_value" placeholder="SN/SC/PC/HLP ID" v-model="searchValue">
                    </div>
                    <div class="col-4">
                      <div>Nama Item</div>
                      <input type="text" class="form-control" name="search_item_name" placeholder="Cari nama Unit/Accessories/Parts" v-model="searchItemName">
                    </div>
                    <div class="col-4" style="padding-left : 0px">
                      <span>Tipe Unit</span>
                      <multiselect v-model="searchUnitType" :options="searchUnitTypeOptions" label="typeName" :allow-empty="true" :select-label="''" :deselect-label="''" placeholder="All" track-by="typeName" :multiple="false" :close-on-select="true" default></multiselect>
                    </div>
                    
                  </div>
                </div>
                <div class="row">
                  <div class="container" style="display : flex;">
                    <div class="col" style="display : flex; justify-content: flex-end; padding-right: 1rem;">
                        <div class="mr-3 py-4" style="width: 100px;">
                          <button type="submit" style="width: 100%;" class="btn btn-primary mr-2" @click="searchData">
                            Search
                          </button>
                        </div>
                        <div class="py-4" style="width: 100px;">
                          <button type="button" style="width: 100%;" class="btn btn-outline-secondary " @click="resetFilter">
                            Reset
                          </button>
                        </div>
                    </div> 
                  </div>
                </div>
              </div>
               
              <p class="text-danger" v-if="dataFound == false && searchValue.length > 0 && searched == true">SN/SC/PC tidak ditemukan</p>
            </div>
            <!-- Table baru -->
            <table class="table table-sm table-bordered table-responsive-sm mt-5">
              <thead>
                <tr>
                  <th>Order Info</th>
                  <th>Product Info</th>
                  <th>Actual Specification</th>
                  <th style="width: 10rem;">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="loadingTable == true">
                  <td colspan="3" class="text-center"><img src="~@/assets/images/load-button.gif"></td>
                </tr>
                
                <template v-else-if="loadingTable == false && data.length > 0">
                  <template v-for="(order,i) in data">
                    <!-- Kasus: order dengan dataProductTicket (multiple items) -->
                    <template v-if="order.dataProductTicket && order.dataProductTicket.length > 0">
                      <!-- Baris pertama: Info utama + Rakit Unit button -->
                      <tr :key="`order-${i}-main`">
                        <td :rowspan="order.dataProductTicket.length" class="align-top" style="max-width: 18rem;">
                          <div style="font-weight: 600;">{{order.companyName}}</div>
                          <div v-if="order.orderCode" class="text-primary" style="cursor: pointer;" @click="toDetail(order.orderId, order.orderCode, order.companyId)">
                            {{order.orderCode}}
                          </div>
                          <div v-else style="margin-top: 10px; margin-bottom: 5px;">-</div>
                        </td>
                        <td style="max-width: 18rem;">
                          <div v-if="order.ticketNo" class="text-primary" style="cursor: pointer;" @click="toTicket(order.ticketId)">
                            {{order.ticketNo}}
                          </div>
                          <div v-else>-</div>
                          <div>{{order.dataProductTicket[0].productName}} {{order.ticketId !== null ? '(Rusak)': ''}}</div>
                          <div>{{order.spec}}</div>
                          <div>Product Code: {{order.productCode || '-'}}</div>
                          <div>Serial Number: {{order.dataProductTicket[0].serialNumber || '-'}}</div>
                          <div>Stock Code: {{order.dataProductTicket[0].stockCode || '-'}}</div>
                          <div class="mb-2">Batch Number: {{order.dataProductTicket[0].batchNo || '-'}}</div>
                        </td>
                        <td class="align-top"></td>
                        <td class="text-center align-middle">
                          <!-- Rakit Unit button (hanya muncul di baris pertama) -->
                          <div v-if="order.ticketNo && order.ticketNo.split('/')[0] == 'HLP' && order.isFullUnit == true">
                            <button v-if="loadingAssembly == false" class="btn btn-primary btn-sm" @click.prevent="doAssemble(order)">
                              Rakit Unit
                            </button>
                            <button v-else class="btn btn-primary btn-sm" disabled>
                              <img src="~@/assets/images/2.gif" style="height: 20px;"> Rakit Unit
                            </button>
                          </div>
                          <div>
                            <button 
                              v-if="order.ticketNo && (order.source == 'ticket' || order.source == 'accessories ticket' || order.source == 'subassemblies ticket')" 
                              class="btn btn-info btn-sm mt-2" 
                              @click.prevent="openHLP(order, 0)">
                              QC Done
                            </button>
                            <br v-if="order.source == 'accessories ticket'">
                            <button class="btn btn-danger btn-sm mt-1" 
                              v-if="order.source == 'accessories ticket'"
                              style="background-color: #BE3846; min-width: 4.731rem;"
                              @click.prevent="showAccessoriesLostModal(order, 0)"
                            >
                              Lost
                            </button>
                          </div>
                        </td>
                      </tr>
                      
                      <!-- Baris untuk setiap item produk -->
                      <tr v-for="(data, j) in order.dataProductTicket" :key="`order-${i}-item-${j}`" v-if="j > 0">
                        <td style="max-width: 18rem;">
                          <div v-if="order.ticketNo" class="text-primary" style="cursor: pointer;" @click="toTicket(order.ticketId)">
                            {{order.ticketNo}}
                          </div>
                          <div v-else>-</div>
                          <div>{{data.productName}} {{order.ticketId !== null ? '(Rusak)': ''}}</div>
                          <div>{{order.spec}}</div>
                          <div>Product Code: {{order.productCode || '-'}}</div>
                          <div>Serial Number: {{data.serialNumber || '-'}}</div>
                          <div>Stock Code: {{data.stockCode || '-'}}</div>
                          <div class="mb-2">Batch Number: {{data.batchNo || '-'}}</div>
                        </td>
                        
                        <td class="align-top">
                          <!-- Actual Specification untuk item ini -->
                          <div v-if="order.bomId && data.bomItem">
                            <!-- <div v-for="(bom, bomId) in data.bomItem" :key="`bom-${i}-${j}-${bomId}`">
                              <div class="container">
                                <div class="row">
                                  <div class="px-0">{{bom.itemGroup + ' : '}}</div>
                                  <div class="">
                                    <div v-for="(qty, qtyIndex) in bom.itemQty" :key="`qty-${i}-${j}-${bomId}-${qtyIndex}`">
                                      {{bom.itemGroup + ' : '}}{{bom.itemName}}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div> -->
                            <div v-for="(bom, bomId) in data.bomItem" :key="`bom-${i}-${j}-${bomId}`">
                              <div class="mb-2">
                                <strong>{{bom.itemGroup}} :</strong>
                                <div class="ml-3">
                                  <div v-for="(qty, qtyIndex) in bom.itemQty" :key="`qty-${i}-${j}-${bomId}-${qtyIndex}`">
                                    • {{bom.itemName}}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div v-else>
                            <div v-for="(value, name) in order.actualSpec" :key="`spec-${name}`">
                              {{name}} : {{value}}
                            </div>
                          </div>
                        </td>
                        
                        <td class="text-center align-middle">
                          <!-- QC Done button untuk item ini -->
                          <button 
                            v-if="order.ticketNo && (order.source == 'ticket' || order.source == 'accessories ticket' || order.source == 'subassemblies ticket')" 
                            class="btn btn-info btn-sm" 
                            @click.prevent="openHLP(order, j)">
                            QC Done
                          </button>
                          <br v-if="order.source == 'accessories ticket'">
                          <button class="btn btn-danger btn-sm mt-1" 
                            v-if="order.source == 'accessories ticket'"
                            style="background-color: #BE3846; min-width: 4.731rem;"
                            @click.prevent="showAccessoriesLostModal(order, j)"
                          >
                            Lost
                          </button>
                        </td>
                      </tr>
                    </template>
                    
                    <!-- Kasus: order dengan dataAccessories -->
                    <template v-else-if="order.dataAccessories && order.dataAccessories.length > 0 && order.source == 'accessories'">
                      <!-- Baris pertama: Info utama -->
                      <tr :key="`order-${i}-acc-main`">
                        <td :rowspan="order.dataAccessories.length" class="align-top" style="max-width: 18rem;">
                          <div style="font-weight: 600;">{{order.companyName}}</div>
                          <div v-if="order.orderCode" class="text-primary" style="cursor: pointer;" @click="toDetail(order.orderId, order.orderCode, order.companyId)">
                            {{order.orderCode}}
                          </div>
                          <div v-else style="margin-top: 10px; margin-bottom: 5px;">-</div>
                          <div v-if="order.ticketNo" class="text-primary" style="cursor: pointer;" @click="toTicket(order.ticketId)">
                            {{order.ticketNo}}
                          </div>
                          <div v-else>-</div>
                        </td>
                        <td class="align-top" v-if="order.dataAccessories[0]">
                          <div class="mb-2">Accessories: {{order.dataAccessories[0].itemName}}</div>
                          <div v-if="!order.dataAccessories[0].batchNo">Total Units: {{order.dataAccessories[0].qty}}</div>
                          <div v-else>
                            <div>Product Code: {{order.productCode || '-'}}</div>
                            <div>Serial Number: {{order.dataAccessories[0].serialNumber || '-'}}</div>
                            <div>Stock Code: {{order.dataAccessories[0].stockCode || '-'}}</div>
                            <div class="mb-2">Batch Number: {{order.dataAccessories[0].batchNo || '-'}}</div>
                          </div>
                        </td>
                        <td class="align-top"></td>
                        <td class="text-center align-middle" v-if="order.dataAccessories[0]">
                          <button class="btn btn-info btn-sm mb-1" @click.prevent="showAccessoriesQcDoneModal(order, 0)">
                            QC Done
                          </button>
                          <br>
                          <button class="btn btn-secondary btn-sm" @click.prevent="showUnmatchAccessoriesModal(order, 0)">
                            Unmatch
                          </button>
                        </td>
                      </tr>
                      
                      <!-- Baris untuk setiap accessories -->
                      <tr v-for="(accData, accIndex) in order.dataAccessories" :key="`order-${i}-acc-${accIndex}`"  v-if="accIndex > 0">
                        <!-- <td style="max-width: 18rem;"></td> -->
                        <td class="align-top" style="max-width: 18rem;">
                          <div class="mb-2">Accessories: {{accData.itemName}}</div>
                          <div v-if="!accData.batchNo">Total Units: {{accData.qty}}</div>
                          <div v-else>
                            <div>Product Code: {{order.productCode || '-'}}</div>
                            <div>Serial Number: {{accData.serialNumber || '-'}}</div>
                            <div>Stock Code: {{accData.stockCode || '-'}}</div>
                            <div class="mb-2">Batch Number: {{accData.batchNo || '-'}}</div>
                          </div>
                        </td>
                        <td class="align-top"></td>
                        
                        <td class="text-center align-middle">
                          <button class="btn btn-info btn-sm mb-1" @click.prevent="showAccessoriesQcDoneModal(order, accIndex)">
                            QC Done
                          </button>
                          <br>
                          <button class="btn btn-secondary btn-sm" @click.prevent="showUnmatchAccessoriesModal(order, accIndex)">
                            Unmatch
                          </button>
                        </td>
                      </tr>
                    </template>
                    
                    <!-- Kasus: order biasa (single item) -->
                    <tr v-else :key="`order-${i}-single`">
                      <td style="max-width: 18rem;">
                        <div v-if="order.companyName" style="font-weight: 600;">{{order.companyName}}</div>
                        <div v-if="order.orderCode" class="text-primary" style="cursor: pointer;" @click="toDetail(order.orderId, order.orderCode, order.companyId)">
                          {{order.orderCode}}
                        </div>
                        <div v-else>-</div>
                        <div v-if="order.ticketNo" class="text-primary" style="cursor: pointer;" @click="toTicket(order.ticketId)">
                          {{order.ticketNo}}
                        </div>
                        <div v-else>-</div>
                        
                      </td>
                      <td>
                        <div>{{order.productName}} {{order.ticketId !== null ? '(Rusak)': ''}}</div>
                        <div>{{order.spec}}</div>
                        <div>Product Code: {{order.productCode || '-'}}</div>
                        <div>Serial Number: {{order.serialNumber || '-'}}</div>
                        <div>Stock Code: {{order.stockCode || '-'}}</div>
                      </td>
                      <td style="max-width: 25rem;">
                        <div v-if="!order.bomId">
                          <div v-for="(value, name) in order.actualSpec" :key="name">{{name}} : {{value}}</div>
                        </div>
                        <div v-else>
                          <!-- <div v-for="(item, index) in order.bomItem" :key="`itemBom-${index}`">
                            <div class="container">
                              <div class="row">
                                <div class="px-0">{{item.itemGroup + ' : '}}</div>
                                <div class="px-2">
                                  <div v-for="(qty, j) in item.itemQty" :key="`${item.itemName}-${index}-${j}`">
                                    {{item.itemName}}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div> -->
                          <div v-for="(bom, bomId) in order.bomItem" :key="`bom-${bomId}`">
                            <div class="mb-2">
                              <strong>{{bom.itemGroup}} :</strong>
                              <div class="ml-3">
                                <div v-for="(qty, qtyIndex) in bom.itemQty" :key="`qty-${bomId}-${qtyIndex}`">
                                  • {{bom.itemName}}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </td>
                      
                      <td class="text-center align-middle">
                        <button 
                          v-if="!order.ticketNo && order.dataAccessories.length == 0" 
                          class="btn btn-info btn-sm mb-1" 
                          @click.prevent="doneQc(order)">
                          QC Done
                        </button>
                        <br v-if="!order.ticketNo && order.source == 'order'">
                        <button 
                          v-if="!order.ticketNo && order.source == 'order'" 
                          class="btn btn-secondary btn-sm" 
                          @click.prevent="showUnmatchQCModal(order)">
                          Unmatch
                        </button>
                      </td>
                    </tr>
                  </template>
                </template>
              </tbody>
            </table>
            <!-- End of table baru -->
            
            <div id="wrapperr">
              <div id="c1" style="display: inline-flex;">
                <div style="margin-right: 10px;">
                  <select class="form-control form-control-sm" v-model="itemPerPage" @change="toDataPage(1)">
                    <option :value="10">10</option>
                    <option :value="40">40</option>
                    <option :value="80">80</option>
                  </select>
                </div>
                <div class="alignLeft total-data">
                  Total Data {{ totalData }}
                </div>
              </div>
              <div id="c2" v-if="totalPage > 0">
                <div class="pagination p8 alignRight">
                  <ul>
                    <a class="is-active link" @click="toDataPage(parseInt(page)-1)" v-if="page != 1">
                      <li>{{'<'}}</li> 
                      </a> 
                      <a class="page">
                      <li>{{ page }} of {{ totalPage }} page</li>
                    </a>
                    <a class="is-active link" @click="toDataPage(parseInt(page) + 1)" v-if="page != totalPage">
                      <li>{{'>'}}</li>
                    </a>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Modals -->
  <div class="modal fade" id="modalQC" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header mb-0">
          <div class="container" v-if="addStockOpt == 0">
            <div class="row justify-content-between">
              <label>{{selectedOrder.productName + ' ' + selectedOrder.spec}}</label>
              <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
          </div>
          <button type="button" class="close" data-dismiss="modal" v-if="addStockOpt == 1">&times;</button>
        </div>
        <div class="modal-body mt-0">
          <div class="text-center" v-if="addStockOpt == 1">
            <label class="text-center text-danger">Pastikan data klien dalam unit sudah di reset</label>
          </div>
          <div v-if="addStockOpt == 0">
            <label>Unit tidak ditemukan di stok, unit dari lessor point {{selectedOrder.fromWarehouse}}</label>
          </div>
          <div>
            <div class="font-weight-bold" v-if="addStockOpt == 1">
              {{selectedOrder.productName + ' ' + selectedOrder.spec}}
            </div>
            <div class="container" v-if="addStockOpt == 1">
              <div class="row align-items-center mb-1">
                <div class="col-lg-2 px-0">Serial Number</div>
                <div class="col-lg-10 px-0">
                  <input type="text" class="form-control" name="sn_value" placeholder="Serial Number" v-model="selectedOrder.serialNumber" disabled>
                </div>
              </div>
              <div class="row align-items-center mb-1">
                <div class="col-lg-2 px-0">Stock Code</div>
                <div class="col-lg-10 px-0">
                  <input type="text" class="form-control" name="sc_value" placeholder="Stock Code" v-model="selectedOrder.stockCode" disabled>
                </div>
              </div>
              <div class="row align-items-start mb-1" v-if="bomExist && (itemGroup == 'CPU' || itemGroup == 'Laptop' || itemGroup == 'WIP' || itemGroup == 'Motherboard' || itemGroup == 'Body')">
                <div class="col-lg-2 px-0">Komponen</div>
                <div class="col-lg-10 px-0">
                  <div class="w-100 border rounded p-2 mb-3" v-if="bomSelected">
                    <div v-for="(item,i) in bomSelected.itemBom" :key="`bomItem-${i}`">
                      <div v-for="(qt, j) in item.itemQty" :key="`${item.itemName}-${i}-${j}`">
                        {{item.itemName}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row align-items-center mb-1" v-if="bomExist == false">
                <div class="col-lg-2 px-0">Katalog Spek</div>
                <div class="col-lg-10 px-0">
                  <input type="text" class="form-control" name="sc_value" placeholder="Katalog Spek" v-model="selectedOrder.spec" disabled>
                </div>
              </div>
            </div>
            <button class="btn btn-primary rounded w-100 my-1" v-if="addStockOpt == 1 && !bomExist && (itemGroup == 'CPU' || itemGroup == 'Laptop' || itemGroup == 'WIP' || itemGroup == 'Motherboard' || itemGroup == 'Body')" @click="openModalBom">Pilih Komponen</button>
            <div class="w-100 border rounded p-2 mb-3" v-if="bomSelected && bomExist == false">
              <div v-for="(itemBom,i) in bomSelected.itemBom" :key="`itemBom-${i}`">
                <div v-for="(item,j) in itemBom.itemQty" :key="`itemBom-${i}-${j}`">
                  {{itemBom.itemName}}
                </div>
              </div>
            </div>
            <div class="container" v-if="addStockOpt == 1">
              <div class="row align-items-center mb-1">
                <div class="col-lg-2 px-0">Hasil QC Unit</div>
                <div class="col-lg-10 px-0">
                  <multiselect :options="actionSelection" v-model="action" track-by="actionName" label="actionName" placeholder="Pilih Hasil QC"></multiselect>
                </div>
              </div>
              <div class="row align-items-start mb-1" v-if="selectedOrder.orderAcc !== null">
                <div class="col-lg-2 px-0">QC Aksesoris</div>
                <div class="col-lg-10 px-0">
                  <div v-for="(acc,i) in selectedOrder.orderAcc" :key="`orderAcc-${i}`">
                    <div class="mx-2">{{acc.itemName}}</div>
                    <!-- <multiselect :options="actionSelection" v-model="actionAcc[i]" track-by="actionName" label="actionName" placeholder="Pilih Hasil QC"></multiselect> -->
                  </div>
                </div>
                <div>

                </div>
              </div>
              <div class="row align-items-center mb-1" v-if="addStockOpt == 1">
                <div class="col-lg-2 px-0">Warehouse</div>
                <div class="col-lg-10 px-0">
                  <multiselect :options="warehouseList" v-model="warehouse" placeholder="Pilih warehouse"></multiselect>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal">Batal</button>
          <div v-if="!processingSubmitReq">
            <button v-if="bomExist == false && !selectedOrder.orderAcc && (itemGroup == 'Laptop' || itemGroup == 'CPU')" type="button" class="btn btn-primary btn-sm" @click="submitQc" :disabled="!bomSelected.itemBom || action == '' || action == null || action.action == 0 || (warehouse == '' || warehouse == null)">Simpan</button>
            <button v-if="bomExist == false && !selectedOrder.orderAcc && !['Laptop','CPU'].includes(itemGroup)" type="button" class="btn btn-primary btn-sm" @click="submitQc" :disabled="action == '' || action == null || action.action == 0 || (warehouse == '' || warehouse == null)">Simpan</button>
            <button v-if="bomExist == false && selectedOrder.orderAcc && (selectedOrder.itemGroup == 'Laptop' || selectedOrder.itemGroup == 'CPU')" type="button" class="btn btn-primary btn-sm" @click="submitQc" :disabled="!bomSelected.itemBom || action == '' || action == null || action.action == 0 || (warehouse == '' || warehouse == null)">Simpan</button>
            <button v-if="bomExist == false && selectedOrder.orderAcc && !['Laptop','CPU'].includes(selectedOrder.itemGroup)" type="button" class="btn btn-primary btn-sm" @click="submitQc" :disabled="action == '' || action == null || action.action == 0 || (warehouse == '' || warehouse == null)">Simpan</button>
            <button v-if="bomExist == true && !selectedOrder.orderAcc" type="button" class="btn btn-primary btn-sm" @click="submitQc" :disabled="action == '' || action == null || action.action == 0 || (warehouse == '' || warehouse == null)">Simpan</button>
            <button v-if="bomExist == true && selectedOrder.orderAcc" type="button" class="btn btn-primary btn-sm" @click="submitQc" :disabled="action == '' || action == null || action.action == 0 || (warehouse == '' || warehouse == null)">Simpan</button>
          </div>
          <div v-else>
            <button type="button" class="btn btn-primary btn-sm" disabled>Menyimpan...</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Pilih Bom -->
  <div class="modal fade" id="modalBom" role="dialog" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div class="modal-content">
        <div class="modal-header mb-0">
          <div class="container">
            <div class="row justify-content-end">
              <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
          </div>
        </div>
        <div class="modal-body mt-0">
          <div v-if="bomSelection.length">
            <div class="col-lg-12 border rounded my-2" style="cursor:pointer;" v-for="(bom,i) in bomSelection" :key="`bom-${i}`" @click="selectBom(bom)">
              <div class="font-weight-bold">{{bom.bomName}}</div>
              <div v-for="(item,j) in bom.itemBom" :key="`${bom.bomName}-${j}`">
                <div v-for="(qty,k) in item.itemQty" :key="`${item.itemName}-${j}-${k}`">
                  {{item.itemName}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal fade" id="modalHLP" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content" v-if="selectedTicket">
        <div class="modal-header mb-0">
          <div class="container">
            <div class="row justify-content-between align-items-start">
              <div>
                <label class="mb-0">{{selectedTicket.productName + ' '}}</label><br>
                <label class="text-primary">{{selectedOrder.ticketNo}}</label>
              </div>
              <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
          </div>
        </div>
        <div class="modal-body mt-0">
          <div class="container">
            <div class="row align-items-center mb-1" v-if="itemGroup == 'PC' || itemGroup == 'Laptop' || itemGroup == 'WIP' || itemGroup == 'Motherboard' || itemGroup == 'Body'">
              <div class="col-lg-2 px-0">Stock Code</div>
              <div class="col-lg-10 px-0">
                <input type="text" class="form-control" name="sc_value" placeholder="Stock Code" :value="selectedOrder.stockCode || '-'" disabled>
              </div>
            </div>
            <div class="row align-items-center mb-1" v-if="itemGroup == 'PC' || itemGroup == 'Laptop' || itemGroup == 'WIP' || itemGroup == 'Motherboard' || itemGroup == 'Body'">
              <div class="col-lg-2 px-0">Serial Number</div>
              <div class="col-lg-10 px-0">
                <input type="text" class="form-control" name="sc_value" placeholder="Stock Code" :value="selectedTicket.serialNumber || '-'" disabled>
              </div>
            </div>
            <div class="row align-items-center mb-1">
              <div class="col-lg-2 px-0">Hasil QC Unit</div>
              <div class="col-lg-10 px-0">
                <multiselect :options="actionSelection" v-model="action" track-by="actionName" label="actionName" placeholder="Pilih Hasil QC"></multiselect>
              </div>
            </div>
            <div class="row align-items-center mb-1">
              <div class="col-lg-2 px-0">Warehouse</div>
              <div class="col-lg-10 px-0">
                <multiselect :options="warehouseList" v-model="warehouse" placeholder="Pilih warehouse"></multiselect>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal">Batal</button>
          <button type="button" class="btn btn-primary btn-sm" @click="submitHLP" :disabled="(action == '' || action == null || action.action == 0)|| (warehouse == '' || warehouse == null)">Simpan</button>
        </div>
      </div>
    </div>
  </div>
  <!-- Modal ticket return QC Done -->
   <ModalReturnTicketQcDone :orderData="selectedOrder" :ticketData="selectedTicket" :toTicketDetail="toTicket" :warehouseList="warehouseList"/>
  <!-- Modal Unmatch -->
  <div class="modal fade" id="modalUnmatchQC" role="dialog" tabindex="-1" data-backdrop="static" data-keyboard="false">
     <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body text-center py-5">
            <!-- icon warning -->
           <div class="warning-icon mb-4">
             <svg width="80" height="80" viewBox="0 0 80 80" fill="none">
                <circle cx="40" cy="40" r="38" stroke="#F5A623" stroke-width="4"/>
                <path d="M40 25V45" stroke="#F5A623" stroke-width="4" stroke-linecap="round"/>
                <circle cx="40" cy="55" r="3" fill="#F5A623"/>
              </svg>
            </div>
            <!-- Text -->
            <p class="mb-4" style="font-size: 18px; color: #666;">
              Apakah {{selectedRowOrder.productCode || selectedRowOrder.serialNumber}} ingin diubah ke Unmatch?
            </p>
            <!-- Buttons -->
            <div class="d-flex justify-content-center gap-3">
              <button 
                type="button" 
                class="btn btn-secondary px-4 mr-2"
                @click="hideUnmatchQCModal"
              >
                Cancel
              </button>
              <button 
                type="button" 
                class="btn btn-primary px-4"
                @click="unmatchQc"
                :disabled="processUnmatch"
              > 
                {{processUnmatch ? 'Processing...' : 'Save'}}
              </button>
            </div>
        </div>
      </div>
     </div>

  </div>
  <!-- Modal QC Done V2 -->
   <ModalAccessoriesQcDone :orderData="selectedOrderAccessoriesData" :toOrderDetail="toDetail" :warehouseList="warehouseList"/>
  <!-- End Of Modal QC Done V2 -->
   <ModalAccessoriesUnmatch :orderData="selectedOrderAccessoriesData" :toOrderDetail="toDetail"/>
  <!-- End Modals -->
   <!-- Modal LOST Accessories -->
  <ModalAccessoriesLost 
    ref="modalAccessoriesLost" 
    :orderData="selectedOrderAccessoriesData" 
    :toOrderDetail="toDetail" 
    :pageType="'qc'"
  />
</div>
</template>

<script>
import SideBar from '../SideBar'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import swal from 'sweetalert'
import Swal from "sweetalert2";
import ModalAccessoriesQcDone from './CustomComponent/ModalAccessoriesQcDone.vue';
import ModalAccessoriesUnmatch from './CustomComponent/ModalAccessoriesUnmatch.vue';
import ModalAccessoriesLost from './CustomComponent/ModalAccessoriesLost.vue';
import ModalReturnTicketQcDone from './CustomComponent/ModalReturnTicketQcDone.vue';

export default {
  name: 'QualityControlPage',
  components: {
    SideBar,
    Multiselect,
    ModalAccessoriesQcDone,
    ModalAccessoriesUnmatch,
    ModalAccessoriesLost,
    ModalReturnTicketQcDone,
  },
  data() {
    return {
      spaceRegex: /[\u00A0\uFEFF\u202F]/g,
      searched: false,
      dataFound: true,
      specCheck: true,
      admin: '',
      permission: [],
      addStockOpt: 0,
      stockFound: false,
      loadingTable: true,
      loadingButtonSave: false,
      page: 0,
      totalPage: 0,
      itemPerPage: 10,
      totalData: 0,
      data: [],
      selectedData: [],
      selectDisplayType: ['LCD', 'LED'],
      searchValue: '',
      searchUnitType : { typeName : 'All'},
      searchItemName: '',
      searchUnitTypeOptions : [
        {
          typeName : 'All',
        },
        {
          typeName : 'Accessories',
        },
        {
          typeName : 'Parts'
        },
        {
          typeName : 'Unit',
        },
      ],
      productType: '',
      productData: {
        catalogName: '',
        catalogSpec: '',
        catalogType: '',
        condition: '',
        lessorPointId: '',
        lessorPointName: '',
        price: '',
        productId: '',
        orderDetailsId: ''
      },
      storageSize: {
        SSD: '',
        HDD: ''
      },
      addStockSpec: {},
      storageType: '',
      addStockInfo: {
        serialNumber: '',
        stockCode: '',
      },
      addSelectCondition: [],
      addCondition: {
        status: '',
        statusName: 'Condition'
      },
      addPoint: {
        pointName: 'Lessor Point',
        pointId: ''
      },
      selectPointName: [],
      selectPointNameSearch: [],
      selectPointNameEdit: [],
      selectProductVarian: [],
      addAction: {
        action: 0,
        actionName: 'None'
      },
      addVarian: {
        productDetail: 'Catalog Spec',
        productId: ''
      },
      addProductType: {
        productTypeName: 'Type',
        productType: ''
      },
      actionSelection: [],
      selectedOrder: {
        actualSpec: '',
        orderDetailsId: '',
        productCode: '',
        productName: '',
        serialNumber: '',
        spec: '',
        stockCode: '',
        stockId: '',
      },
      formattedSpec: {},
      bomExist: false,
      warehouseList: [],
      warehouse: '',
      action: '',
      actionAcc: [''],
      bomSelected: '',
      bomSelection: [],
      itemGroup: '',
      allAccDone: true,
      selectedTicket: {
        ticketDeviceId: '',
        stockId: '',
        productName: '',
        serialNumber: '',
        bomId: '',
        bomItem: [],
        itemGroup: ""
      },
      loadingAssembly : false,
      selectedOrderAccessoriesData : '',
      processingSubmitReq : false,
      processUnmatch : false,
      selectedRowOrder:'',
    }
  },
  methods: {
    assembleProcess(data){
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary ml-2",
          cancelButton: "btn btn-danger"
        },
        buttonsStyling: false
      });
      this.loadingAssembly = true
      const body = data.dataProductTicket.find(item => item.itemGroup == 'Body') ? data.dataProductTicket.find(item => item.itemGroup == 'Body') : data.dataProductTicket.find(item => item.itemGroup == 'Motherboard')
      const itemBom = data.dataProductTicket.map(item => `${item.stockId ? item.stockId : ''}`)
      let payload = {
        bom : itemBom,
        itemName : `${data.productName} ${data.spec}`,
        ticketId : data.ticketId,
        serialNumber : body ? body.serialNumber : '' ,
        warehouse : data.fromWarehouse,
      }

      this.$http
        .post(process.env.ASSEMBLY_QC, payload,
        {
          headers: { "Asani-Token": localStorage.getItem("jwt") },
        })
        .then((response) => {
          if (response.status == 200 && response.data.status == 200) {
            swalWithBootstrapButtons
              .fire({
                title: "Success",
                text: response.data.message,
                icon: "success",
              })
              .then((result) => {
                if (result.isConfirmed) {
                  this.loadingAssembly = false
                  window.location.reload()
                }
              });
          } else {
            swalWithBootstrapButtons
              .fire({
                title: "Failed",
                text: `${response.data.message}`,
                icon: "error",
              })
              .then((result) => {
                if (result.isConfirmed) {
                  this.loadingAssembly = false
                }
              });
          }
        })
        .catch((error) => {
          swalWithBootstrapButtons
            .fire({
              title: "Failed",
              text: `${error.response.data.message}`,
              icon: "error",
            })
            .then((result) => {
              if(error.response.data.status == 401) {
                this.handleLogout()
              }
              this.loadingAssembly = false
            });
        });
    },
    doAssemble(data) {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary ml-2",
          cancelButton: "btn btn-danger"
        },
        buttonsStyling: false
      });

      swalWithBootstrapButtons
        .fire({
          title:
            "<strong style='font-size : 24px; font-weight : 600;'>Apakah kamu yakin ingin menggabungkan komponen menjadi satu unit ?</strong>",
          icon: "warning",
          width: "39rem",
          html: `
            <div class="mt-3" style="max-width : 100%; font-size : 16px; color: #F06400">
              Tindakan ini tidak dapat diubah.
            </div>
          `,
          reverseButtons: true,
          showCancelButton: true,
          focusConfirm: false,
          confirmButtonText: `
            Ya, saya yakin!
          `,
          cancelButtonText: `
            Batalkan
          `,
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.assembleProcess(data)
            // swalWithBootstrapButtons
            //   .fire({
            //     title: "Success",
            //     text: `Perakitan unit berhasil.`,
            //     icon: "success",
            //   })
            //   .then((result) => {
            //     if (result.isConfirmed) {
            //     }
            //   });
          } else {
            console.log("Batal");
          }
        });
    },
    openHLP(data, index) {
      this.itemGroup = ''
      this.action = ''
      this.warehouse = ''
      this.actionSelection = []
      this.itemGroup = data.dataProductTicket[index].itemGroup
      this.selectedOrder = data
      this.selectedTicket = data.dataProductTicket[index]
      this.getParentWarehouse()
      console.log(data)
      this.actionSelection.push({ action: 0, actionName: 'None' }, { action: 4, actionName: 'Ready Stock' }, { action: 7, actionName: 'Trouble Stock' })
      $('#modalReturnTicketQcDone').modal('show')
    },
    submitHLP() {
      this.processingSubmitReq = true
      let order = this.selectedOrder
      this.itemGroup = order.itemGroup
      console.log('submit', order)
      this.$http.post(process.env.QC_DONE, {
          data: {
            actualSpec: order.actualSpec,
            orderDetailsId: order.orderDetailsId,
            productCode: order.productCode ? order.productCode.replace(this.spaceRegex, ' ') : order.productCode,
            productName: order.productName ? order.productName.replace(this.spaceRegex, ' ') : order.productName,
            serialNumber: this.selectedTicket.serialNumber ? this.selectedTicket.serialNumber.replace(this.spaceRegex, ' ') : this.selectedTicket.serialNumber,
            spec: order.spec,
            stockCode: this.selectedTicket.stockCode,
            stockId: this.selectedTicket.stockId,
            companyName: order.companyName ? order.companyName.replace(this.spaceRegex, ' ') : order.companyName,
            companyId: order.companyId,
            ticketDeviceId: this.selectedTicket.ticketDeviceId,
            ticketId: order.ticketId,
            ticketNo: order.ticketNo,
            orderCode: order.orderCode,
            returnBy: order.returnBy,
            bomId: this.selectedTicket.bomId || null,
            bomItem: this.selectedTicket.bomItem,
            fromWarehouse: order.fromWarehouse,
            orderAcc: order.orderAcc,
            itemGroup: this.selectedTicket.itemGroup
          },
          status: this.action.actionName,
          parentWarehouse: this.warehouse
        }, { 
          headers: { "Asani-Token": localStorage.getItem("jwt") },
          timeout : 300 * 1000, 
        })
        .then(res => {
          console.log(res)
          if (res.data.status == 200) {
            swal('Sukses', 'Data berhasil disimpan', 'success').then(() => {
              this.processingSubmitReq = false
              window.location.reload()
            })
          } else {
            swal('Error', res.data.message, 'error')
            this.processingSubmitReq = false
          }
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
            this.processingSubmitReq = false
          })
        })
    },
    toDetail(id, orderCode, companyId) {
      let url = this.$router.resolve({
        path: '/order/detail/' + id,
        query: {
          orderCode: orderCode,
          companyIdDetail: companyId
        }
      })
      window.open(url.href, '_blank')
    },
    openModalBom() {
      $('#modalBom').modal('show')
    },
    selectBom(data) {
      this.bomSelected = data
      console.log('selected', data)
      $('#modalBom').modal('hide')
    },
    toTicket(id) {
      let url = this.$router.resolve('/resolution/detail/' + id)
      window.open(url.href, '_blank')
    },
    sidebar() {
      $("#wrapper").toggleClass("toggled");
    },
    toPage(e) {
      this.$router.push(e)
    },
    resetFilter () {
      this.searchValue = '';
      this.searchUnitType = null;
      this.searchItemName = '';
      this.searchData()
    },
    searchData() {
      this.$router.push({
          path: '/return/quality-control',
          query: {
            tipe : this.searchUnitType ? this.searchUnitType.typeName : '',
            uniqueId: this.searchValue,
            itemName : this.searchItemName,
            itemPerPage: this.itemPerPage,
            page: 1
          }
        })
    },
    toDataPage(val) {
      this.page = val
      window.scrollTo(0, 0)
      // localStorage.setItem('qc-cache', JSON.stringify({ itemPerPage: this.itemPerPage, page: this.page }))
      this.$router.push({
          path: '/return/quality-control',
          query: {
            uniqueId: '',
            tipe: this.searchUnitType ? this.searchUnitType.typeName : '',
            itemPerPage: this.itemPerPage,
            page: this.page
          }
        })
    },
    resetDoneQc() {
      this.specCheck = true
      this.selectedData = []
      this.formattedSpec = {}
      this.storageType = ''
      this.productData = {
        catalogName: '',
        catalogSpec: '',
        catalogType: '',
        condition: '',
        lessorPointId: '',
        lessorPointName: '',
        price: '',
        productId: '',
        orderDetailsId: ''
      }
      this.addStockSpec = {}
      this.addStockInfo = {
        serialNumber: '',
        stockCode: '',
      }
      this.addProductType = {
        productTypeName: 'Type',
        productType: ''
      }
      this.addAction = {
        action: 0,
        actionName: 'None'
      }
      this.addVarian = {
        productDetail: 'Catalog Spec',
        productId: ''
      }
      this.addPoint = {
        pointName: 'Lessor Point',
        pointId: ''
      }
      this.addStockOpt = 0
      this.productType = ''
      this.actionSelection = []
      this.stockFound = false
      this.selectedOrder = {
        actualSpec: '',
        orderDetailsId: '',
        productCode: '',
        productName: '',
        serialNumber: '',
        spec: '',
        stockCode: '',
        stockId: '',
      }
      this.bomSelected = ''
      this.warehouse = ''
      this.action = ''
      this.actionAcc = ['']
      this.itemGroup = ''
    },
    doneQc(order) {
      this.resetDoneQc()
      this.getParentWarehouse()
      if (order.bomId) {
        this.bomExist = true
      } else {
        this.bomExist = false
      }
      this.itemGroup = order.itemGroup
      this.actionAcc = []
      this.selectedOrder = order
      if (order.orderAcc) {
        for (let i in order.orderAcc) {
          this.actionAcc.push('')
        }
      }
      this.actionSelection.push({ action: 0, actionName: 'None' }, { action: 4, actionName: 'Ready Stock' }, { action: 7, actionName: 'Trouble Stock' })
      const scsn = order.serialNumber ? order.serialNumber.replace(this.spaceRegex, ' ') : order.serialNumber
      this.$http.get(process.env.GET_DATA_DETAIL_ERP + `/${scsn}`, {
          headers: {
            "Asani-Token": localStorage.getItem("jwt")
          }
        })
        .then(res => {
          if (res.data.status == 200) {
            this.stockFound = true
            this.addStockOpt = 1
            this.selectedOrder = {
              actualSpec: order.actualSpec,
              orderDetailsId: order.orderDetailsId,
              productCode: order.productCode,
              productName: res.data.content.itemName,
              serialNumber: res.data.content.serialNumber,
              spec: order.spec,
              stockCode: res.data.content.stockCode,
              stockId: res.data.content.itemCode,
              accessories: order.orderAcc,
              companyName: order.companyName,
              companyId: order.companyId,
              ticketDeviceId: order.ticketDeviceId,
              ticketId: order.ticketId,
              ticketNo: order.ticketNo,
              orderCode: order.orderCode,
              returnBy: order.returnBy,
              bomId: order.bomId || null,
              bomItem: order.bomItem,
              fromWarehouse: order.fromWarehouse,
              orderAcc: order.orderAcc,
              itemGroup: order.itemGroup
            }
            // if (res.data.content.accessories) {
            //   this.selectedOrder.accessories = res.data.content.accessories
            // }
            if (res.data.content.bom.length) {
              this.bomExist = true
              this.bomSelected = {
                itemBom : res.data.content.bom,
                bomName : res.data.content.bomName
              }

              $("#modalQC").modal('show')
            } else {
              this.bomExist = false
              this.$http.get(process.env.GET_CATALOG_BOM + res.data.content.itemCode, {
                  headers: {
                    "Asani-Token": localStorage.getItem("jwt")
                  }
                })
                .then(r => {

                  if (r.data.status == 200) {
                    if (r.data.content && r.data.content.length) {
                      this.bomSelection = r.data.content
                    }
                  }

                  $("#modalQC").modal('show')
                })
                .catch(error => {
                  swal("Sorry", error.response.data.message, "error", {
                    button: "Ok",
                  }).then(v => {
                    if(error.response.data.status == 401) {
                      this.handleLogout()
                    }
                  })
                })
            }
          } else {
            this.addStockOpt = 1
            this.stockFound = false
            // $("#modalQC").modal('show')
            swal('', 'Produk tidak terdaftar di stok', 'error')
          }
        })

    },
    submitQc() {
      this.processingSubmitReq = true;
      let order = this.selectedOrder
      if (order.orderAcc || order.orderAcc !== null) {
        this.actionAcc.forEach((el, i) => {
          if (el.action == 4) {
            order.orderAcc[i].isGoodStock = true
          } else {
            order.orderAcc[i].isGoodStock = false
          }
        })
      }
      console.log('submit', order)
      if (this.addStockOpt == 1 && this.bomExist) {
        this.$http.post(process.env.QC_DONE, {
            data: {
              actualSpec: order.actualSpec,
              orderDetailsId: order.orderDetailsId,
              productCode: order.productCode ? order.productCode.replace(this.spaceRegex, ' ') : order.productCode,
              productName: order.productName ? order.productName.replace(this.spaceRegex, ' ') : order.productName,
              serialNumber: order.serialNumber ? order.serialNumber.replace(this.spaceRegex, ' ') : order.serialNumber,
              spec: order.spec,
              stockCode: order.stockCode ? order.stockCode.replace(this.spaceRegex, ' ') : order.stockCode,
              stockId: order.itemCode,
              companyName: order.companyName ? order.companyName.replace(this.spaceRegex, ' ') : order.companyName,
              companyId: order.companyId,
              ticketDeviceId: order.ticketDeviceId,
              ticketId: order.ticketId,
              ticketNo: order.ticketNo ? order.ticketNo.replace(this.spaceRegex, ' ') : order.ticketNo,
              orderCode: order.orderCode ? order.orderCode.replace(this.spaceRegex, ' ') : order.orderCode,
              returnBy: order.returnBy,
              bomId: order.bomId || null,
              bomItem: order.bomItem,
              fromWarehouse: order.fromWarehouse,
              orderAcc: order.orderAcc,
              batchNo: '',
            },
            status: this.action.actionName,
            parentWarehouse: this.warehouse
          }, { 
            headers: { "Asani-Token": localStorage.getItem("jwt") },
            timeout : 300 * 1000, 
          })
          .then(res => {
            if (res.data.status == 200) {
              swal('Sukses', 'Data berhasil disimpan', 'success').then(() => {
                this.processingSubmitReq = false
                window.location.reload()
              })
            } else {
              swal('Error', res.data.message, 'error')
              this.processingSubmitReq = false
            }
          })
          .catch(error => {
            swal("Sorry", error.response.data.message, "error", {
              button: "Ok",
            }).then(v => {
              if(error.response.data.status == 401) {
                this.handleLogout()
              }
              this.processingSubmitReq = false
            })
          })
      } else if (this.addStockOpt == 1 && !this.bomExist) {
        this.$http.post(process.env.QC_DONE, {
            data: {
              actualSpec: order.actualSpec,
              orderDetailsId: order.orderDetailsId,
              productCode: order.productCode ? order.productCode.replace(this.spaceRegex, ' ') : order.productCode,
              productName: order.productName ? order.productName.replace(this.spaceRegex, ' ') : order.productName,
              serialNumber: order.serialNumber ? order.serialNumber.replace(this.spaceRegex, ' ') : order.serialNumber,
              spec: order.spec ? order.spec.replace(this.spaceRegex, ' ') : order.spec,
              stockCode: order.stockCode ? order.stockCode.replace(this.spaceRegex, ' ') : order.stockCode,
              stockId: order.itemCode ? order.itemCode.replace(this.spaceRegex, ' ') : order.itemCode,
              companyName: order.companyName ? order.companyName.replace(this.spaceRegex, ' ') : order.companyName,
              companyId: order.companyId,
              ticketDeviceId: order.ticketDeviceId,
              ticketId: order.ticketId,
              ticketNo: order.ticketNo ? order.ticketNo.replace(this.spaceRegex, ' ') : order.ticketNo,
              orderCode: order.orderCode ? order.orderCode.replace(this.spaceRegex, ' ') : order.orderCode,
              returnBy: order.returnBy,
              bomId: this.bomSelected.bomName || null,
              bomItem: this.bomSelected,
              fromWarehouse: order.fromWarehouse,
              orderAcc: order.orderAcc,
              batchNo : '',
            },
            status: this.action.actionName,
            parentWarehouse: this.warehouse
          }, { 
            headers: { "Asani-Token": localStorage.getItem("jwt") },
            timeout : 300 * 1000, 
          })
          .then(res => {
            if (res.data.status == 200) {
              swal('Sukses', 'Data berhasil disimpan', 'success').then(() => {
                this.processingSubmitReq = false
                window.location.reload()
              })
            } else {
              swal('Error', res.data.message, 'error')
              this.processingSubmitReq = false
            }
          })
          .catch(error => {
            swal("Sorry", error.response.data.message, "error", {
              button: "Ok",
            }).then(v => {
              if(error.response.data.status == 401) {
                this.handleLogout()
              }
              this.processingSubmitReq = false
            })
          })
      }
    },
    showAccessoriesQcDoneModal(order, accNo) {
      this.getParentWarehouse(true)
      this.selectedOrderAccessoriesData = {...order, dataAccessories : order.dataAccessories[accNo]}
      console.log(this.selectedOrderAccessoriesData)
      $('#modalAccessoriesQcDone').modal('show')
    },
    showUnmatchAccessoriesModal (order, accNo) {
      this.selectedOrderAccessoriesData = {...order, dataAccessories : order.dataAccessories[accNo], totalQty : order.dataAccessories[accNo].qty}
      $('#modalAccessoriesUnmatch').modal('show')
    },
    showAccessoriesLostModal (order, accNo) {
      console.log(order)
      this.selectedOrderAccessoriesData = {...order, dataAccessories : order.dataProductTicket[accNo], ...order.dataProductTicket [accNo]}
      // Panggil showModal() melalui $refs
      this.$nextTick(() => {
        this.$refs.modalAccessoriesLost.showModal()
      })
      
      // $('#modalAccessoriesLost').modal('show')
    },
    showUnmatchQCModal(order){
      console.log('show dong')
      $('#modalUnmatchQC').modal('show')
      this.selectedRowOrder = order
    },
    hideUnmatchQCModal(){
      $('#modalUnmatchQC').modal('hide')
    },
    unmatchQc(){
      this.processUnmatch = true
      const order = this.selectedRowOrder
      this.$http.post(process.env.UNMATCH_QC, {
        orderId: order.orderId,
        orderDetailsId: order.orderDetailsId,
        productCode: order.productCode,
        serialNumber: order.serialNumber,
      }, {
        timeout: 300 * 1000,
        headers: { "Asani-Token": localStorage.getItem("jwt") },
      })
      .then(res => {
        if (res.data.status == 200) {
          swal("Success", "Success Unmatched", "success", {
            button: "Close",
          }).then(() => {
            this.resetDoneQc()
            if (this.totalData == 1) {
              this.toDataPage(1)
              this.searchValue = ''
            }
            this.processUnmatch = false
            $('modalUnmatchQC').modal('hide')
            this.getData()
            location.reload()
          })
        } else {
          swal("Sorry", res.data.message, "error", {
            button: "Close",
          }).then(() => {
            this.processUnmatch = false;
            $('modalUnmatchQC').modal('hide')
          })
        }
      })
      .catch(error => {
        swal("Sorry", error.response.data.message, "error", {
          button: "Ok",
        }).then(v => {
          if(error.response.data.status == 401) {
            this.handleLogout()
          }
        })
      })
    },
    getData() {
      this.resetDoneQc()
      if (this.searchValue.length > 0) {
        this.searched = true
      }
      this.page = this.$route.query.page;
      this.itemPerPage = this.$route.query.itemPerPage;
      this.searchValue = this.$route.query.uniqueId;
      this.searchItemName = this.$route.query.itemName || '';
      this.searchUnitType = this.searchUnitTypeOptions.find(item => item.typeName == this.$route.query.tipe) || {typeName : 'All'}
      this.loadingTable = true
      this.$http.post(process.env.SEARCH_QC, {
          uniqueId: this.searchValue.replace(this.spaceRegex, ' '),
          itemName: this.searchItemName,
          page: Number(this.page),
          itemPerPage: Number(this.itemPerPage),
          tipe : this.searchUnitType.typeName
        }, {
          timeout: 30 * 1000,
          headers: { "Asani-Token": localStorage.getItem("jwt") },
        })
        .then(res => {
          if (res.data.status == 200) {
            if (res.data.content.data === null) {
              this.dataFound = false
              this.loadingTable = false
              swal("Sorry", "Data tidak ditemukan.", "error", {
                button: "Close",
              })
              return null
            }
            if (res.data.content.data.length > 0) {
              // const chunk = (arr, size) =>
              //   Array.from({ length: Math.ceil(arr.length / size) }, (v, i) =>
              //     arr.slice(i * size, i * size + size)
              //   )
              // let result = chunk(res.data.content, this.itemPerPage)
              this.totalPage = res.data.content.totalPage
              this.totalData = res.data.content.totalData
              this.loadingTable = false
              this.data = res.data.content.data.map(el=> ({...el, actualSpec: el.actualSpec? JSON.parse(el.actualSpec): ""}))
              this.loadingTable = false
              this.dataFound = true
              // localStorage.setItem('qc-cache', JSON.stringify({ itemPerPage: this.itemPerPage, page: this.page }))
            } else {
              this.dataFound = false
              this.loadingTable = false
            }
          } else {
            swal("Sorry", res.data.message, "error", {
              button: "Close",
            })
            this.loadingTable = false
          }
          this.loadingTable = false
        })
        .catch(error => {
          this.loadingTable = false
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
    },
    getProductCondition() {
      this.$http.post(process.env.GET_PRODUCT_ALL_CONDITION, {
          productName: this.productData.catalogName ? this.productData.catalogName.replace(this.spaceRegex, ' ') : this.productData.catalogName,
          productType: this.productData.catalogType,
          productId: this.productData.productId
        }, {
          headers: { 'Asani-Token': localStorage.getItem('jwt') }
        })
        .then(response => {
          if (response.data.status == 400) {
            swal("Sorry", response.data.message, "error", {
              button: "Close",
            })
          } else if (response.data.status == 200) {
            this.addSelectCondition = []
            for (var i = 0; i < response.data.content.productCondition.length; i++) {
              this.addSelectCondition.push({
                status: response.data.content.productCondition[i].condition,
                statusName: response.data.content.productCondition[i].conditionName
              })
            }
          }
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
    },
    getAllLesorPoint() {
      this.$http.get(process.env.GET_ALL_LESSOR_POINT, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        .then(response => {
          if (response.data.status == 400) {
            swal("Sorry", response.data.message, "error", {
              button: "Ok",
            })

          } else {
            this.selectPointName = []
            this.selectPointNameSearch = []
            this.selectPointNameEdit = []
            this.selectPointNameSearch.push({
              pointId: 'All',
              pointName: 'All'
            })
            for (var i = 0; i < response.data.content.data.length; i++) {
              if (response.data.content.data[i].stock == 1) {
                this.selectPointName.push({
                  pointId: response.data.content.data[i].pointId,
                  pointName: response.data.content.data[i].pointName,
                  lessorId: response.data.content.data[i].lessorId,
                  stock: response.data.content.data[i].stock,
                })
                this.selectPointNameSearch.push({
                  pointId: response.data.content.data[i].pointId,
                  pointName: response.data.content.data[i].pointName.substring(response.data.content.data[i].pointName.indexOf("-") + 2),
                  lessorId: response.data.content.data[i].lessorId,
                  stock: response.data.content.data[i].stock,
                })
                this.selectPointNameEdit.push({
                  pointId: response.data.content.data[i].pointId,
                  pointName: response.data.content.data[i].pointName,
                  lessorId: response.data.content.data[i].lessorId,
                  stock: response.data.content.data[i].stock,
                })
              }
            }
          }
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
    },
    getProductVarian() {
      this.$http.post(process.env.GET_PRODUCT_VARIAN, {
          productName: this.productData.catalogName,
          productType: this.productData.catalogType
        }, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        .then(response => {
          if (response.data.status == 400) {
            swal("Sorry", response.data.message, "error", {
              button: "Ok",
            }) 

          } else if (response.data.status == 200) {
            this.selectProductVarian = response.data.content.productVarian
            var specification = ''
            for (var i = 0; i < this.selectProductVarian.length; i++) {
              if (this.addProductType.productType == '1' || this.addProductType.productType == '2') {
                specification = JSON.parse(this.selectProductVarian[i].productDetail).processor + '/' + JSON.parse(this.selectProductVarian[i].productDetail).ram + 'GB/' + JSON.parse(this.selectProductVarian[i].productDetail).storage + '/' + JSON.parse(this.selectProductVarian[i].productDetail).vga
                this.selectProductVarian[i].productDetail = specification
              } else if (this.addProductType.productType == '3') {
                specification = JSON.parse(this.selectProductVarian[i].productDetail).displaySize + ' Inch'
                this.selectProductVarian[i].productDetail = specification
              } else if (this.addProductType.productType == '4') {
                specification = JSON.parse(this.selectProductVarian[i].productDetail).colorTech
                this.selectProductVarian[i].productDetail = specification
              } else if (this.addProductType.productType == '5' || this.addProductType.productType == '6') {
                specification = JSON.parse(this.selectProductVarian[i].productDetail).processor + '/' + JSON.parse(this.selectProductVarian[i].productDetail).ram + 'GB/' + JSON.parse(this.selectProductVarian[i].productDetail).storage
                this.selectProductVarian[i].productDetail = specification
              } else {
                specification = JSON.parse(this.selectProductVarian[i].productDetail).model
                this.selectProductVarian[i].productDetail = specification
              }
            }
          }
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
    },
    async handleLogout() {
      try {
        const response = await this.$http.post(process.env.LOGOUT, {}, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          })
          return
        }

      } catch (error) {
        if(error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          })
          return
        }
      }
      localStorage.removeItem('jwt')
      localStorage.removeItem('admin_name')
      localStorage.removeItem('roles')
      localStorage.removeItem('user_email')
      localStorage.removeItem('admin_id')
      localStorage.removeItem('qc-cache')
      localStorage.removeItem('changeCatalogPermission')
      this.$router.push('/')
    },
    cekLogin() {
      if (localStorage.getItem('jwt') == null) {
        this.$router.push('/')
        localStorage.removeItem('qc-cache')
      }
    },
    cekPermission() {
      this.permission = localStorage.getItem('roles').replace(/"/g, "").replace("[", "").replace("]", "").split(",")
      for (var i = 0; i < this.permission.length; i++) {
        if (this.permission[i] == "1") {
          this.viewDashboard = true
        }
        if (this.permission[i] == "2.1") {
          this.viewOrder = true
        }
        if (this.permission[i] == "2.2") {
          this.editOrder = true
        }
        if (this.permission[i] == '3.1') {
          this.viewReturn = true
        }
        if (this.permission[i] == '3.2') {
          this.editReturn = true
        }
        if (this.permission[i] == '4.1') {
          this.viewProduct = true
        }
        if (this.permission[i] == '4.2') {
          this.editProduct = true
        }
        if (this.permission[i] == '5.1') {
          this.viewPairing = true
        }
        if (this.permission[i] == '5.2') {
          this.editPairing = true
        }
        if (this.permission[i] == '6') {
          this.viewReconcile = true
        }
        if (this.permission[i] == '7.1') {
          this.viewResolution = true
        }
        if (this.permission[i] == '7.2') {
          this.editResolution = true
        }
        if (this.permission[i] == '8.1') {
          this.viewLessor = true
        }
        if (this.permission[i] == '8.2') {
          this.editLessor = true
        }
        if (this.permission[i] == '9.1') {
          this.viewLessee = true
        }
        if (this.permission[i] == '9.2') {
          this.editLessee = true
        }
        if (this.permission[i] == '10') {
          this.viewEmployee = true
        }
      }
      if (this.viewOrder == false) {
        this.$router.push('/')
      }
    },
    getParentWarehouse(isAccessories = false) {
      let url = process.env.QC_GET_PARENT_WAREHOUSE
      if ((this.selectedTicket && this.selectedTicket.isPart != null) || isAccessories) { 
        if(isAccessories) {
          url += '?isPart=' + isAccessories
        } else {
          url += '?isPart=' + this.selectedTicket.isPart
        }
      }
      this.$http.get(url, { headers: { 'Asani-Token': localStorage.getItem('jwt') } })
        .then(res => {
          console.log('warehouses', res)
          this.warehouseList = res.data.content
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
    }
  },
  watch: {
    searchValue: {
      handler: function (val) {
        this.dataFound = true
      }
    },
    addStockSpec: {
      handler: function (val, oldVal) {
        let counter = 0
        for (let key in this.addStockSpec) {
          if (this.addStockSpec[key] == '') counter++
          else counter--
        }
        if (counter > 0) this.specCheck = false
        else this.specCheck = true
      },
      deep: true
    },
    actionAcc: {
      handler: function (val) {
        this.allAccDone = true
        for (let i in this.actionAcc) {
          if (!this.actionAcc[i] || this.actionAcc[i] == '' || this.actionAcc[i] == null || this.actionAcc[i].action == 0) {
            this.allAccDone = false
            console.log(this.allAccDone)
          }
        }
        console.log(this.allAccDone)

      }
    },
    action: {
      handler: function (val) {
        console.log(this.action)
      }
    },
    warehouse: {
      handler: function (val) {
        console.log(this.warehouse)
      }
    }
  },
  created() {
    this.cekLogin()
    this.cekPermission()
    this.admin = localStorage.getItem('admin_name')
    if (localStorage.getItem('qc-cache')) {
      let cache = JSON.parse(localStorage.getItem('qc-cache'))
      this.page = cache.page
      this.itemPerPage = cache.itemPerPage
    }
    this.getData()

  }
}
</script>

<style scoped>
#filterPart {
  padding: 1rem;
  background-color: #F8F9FA;
}

.one-line-sm {
  display: flex;
}

.pagination {
  padding: 0px 0;
}

.pagination ul {
  margin: 0;
  padding: 0;
  list-style-type: none;
}

.pagination a {
  display: inline-block;
  padding: 1px 6px;
  color: #222;
}

.p8 a {
  background-color: #2797FB;
  /*margin: auto 5px;*/
  color: #fff;
  /*font-weight: bold;*/
  border: 1px solid #2797FB;
}

.p8 a:hover {
  text-decoration: none;
}

.p8 a.page:hover {
  text-decoration: none;
  color: #fff;
}

.p8 .is-active {
  background-color: #fff;
  color: #2797FB;
}

.alignleft {
  float: left;
}

.alignright {
  float: right;
}

.pagg {
  display: inline-flex;
  overflow: auto;
}

.total-data {
  padding: 11px 0px;
  font-size: 14px;
  color: #343A40;
}

#wrapperr {
  overflow: auto;
  margin: 5px 3px;
}

#c1 {
  float: left;
}

#c2 {
  float: right;
}

.search-table {
  padding-bottom: 7px;
  margin-top: -5px;
  margin-left: -15px;
}

.active {
  color: #2797FB;
}

.right-dropdown {
  margin-left: 7px;
}

.account-div {
  margin: 2px 2px;
}

.right-arrow {
  margin-left: auto;
}

.brand-logo {
  width: 120px;
}

.menu-title {
  margin-left: 1.125rem;
}

.menu-title-order {
  margin-left: 1.95rem;
}

.menu-title-payment {
  margin-left: 1.525rem;
}

ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
  /*width: 200px;*/
  /*background-color: #f1f1f1;*/
}

li.sidebar a {
  display: block;
  color: #000;
  padding: 8px 63px;
  text-decoration: none;
}

li a.active {
  background-color: #4CAF50;
  color: white;
}

li a:hover:not(.active) {
  background-color: #2797FB;
  color: white;
}

.redirect-link {
  text-decoration: underline #2797FB;
  cursor: pointer;
}

.nav-side-menu {
  overflow: auto;
  font-family: verdana;
  font-size: 12px;
  font-weight: 200;
  background-color: #2e353d;
  position: fixed;
  top: 0px;
  width: 300px;
  height: 100%;
  color: #e1ffff;
}

.nav-side-menu .brand {
  background-color: #23282e;
  line-height: 50px;
  display: block;
  text-align: center;
  font-size: 14px;
}

.nav-side-menu .toggle-btn {
  display: none;
}

.nav-side-menu ul,
.nav-side-menu li {
  list-style: none;
  padding: 0px;
  margin: 0px;
  line-height: 35px;
  cursor: pointer;
}

.nav-side-menu ul :not(collapsed) .arrow:before,
.nav-side-menu li :not(collapsed) .arrow:before {
  font-family: FontAwesome;
  content: "\f078";
  display: inline-block;
  padding-left: 10px;
  padding-right: 10px;
  vertical-align: middle;
}

.nav-side-menu ul .active,
.nav-side-menu li .active {
  border-left: 3px solid #d19b3d;
  background-color: #4f5b69;
}

.nav-side-menu ul .sub-menu li.active,
.nav-side-menu li .sub-menu li.active {
  color: #d19b3d;
}

.nav-side-menu ul .sub-menu li.active a,
.nav-side-menu li .sub-menu li.active a {
  color: #d19b3d;
}

.nav-side-menu ul .sub-menu li,
.nav-side-menu li .sub-menu li {
  background-color: #181c20;
  border: none;
  line-height: 28px;
  border-bottom: 1px solid #23282e;
  margin-left: 0px;
}

.nav-side-menu ul .sub-menu li:hover,
.nav-side-menu li .sub-menu li:hover {
  background-color: #020203;
}

.nav-side-menu ul .sub-menu li:before,
.nav-side-menu li .sub-menu li:before {
  font-family: FontAwesome;
  content: "\f105";
  display: inline-block;
  padding-left: 10px;
  padding-right: 10px;
  vertical-align: middle;
}

.nav-side-menu li {
  padding-left: 0px;
  border-left: 3px solid #2e353d;
  border-bottom: 1px solid #23282e;
}

.nav-side-menu li a {
  text-decoration: none;
  color: #e1ffff;
}

.nav-side-menu li a i {
  padding-left: 10px;
  width: 20px;
  padding-right: 20px;
}

.nav-side-menu li:hover {
  border-left: 3px solid #d19b3d;
  background-color: #4f5b69;
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  -o-transition: all 1s ease;
  -ms-transition: all 1s ease;
  transition: all 1s ease;
}

@media (max-width: 767px) {
  .nav-side-menu {
    position: relative;
    width: 100%;
    margin-bottom: 10px;
  }

  .nav-side-menu .toggle-btn {
    display: block;
    cursor: pointer;
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 10 !important;
    padding: 3px;
    background-color: #ffffff;
    color: #000;
    width: 40px;
    text-align: center;
  }

  .brand {
    text-align: left !important;
    font-size: 22px;
    padding-left: 20px;
    line-height: 50px !important;
  }
}

@media (min-width: 767px) {
  .nav-side-menu .menu-list .menu-content {
    display: block;
  }
}

@media (max-width: 573px) {
  .mobile-div {
    padding: 2px 0px;
  }
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
</style>



// WEBPACK FOOTER //
// src/components/QC/QualityControl.vue